import { request } from './client';

export type YoutubeTopicStatus = 'ACTIVE' | 'ARCHIVED';

export interface YoutubeTopic {
  id: number;
  name: string;
  keyword: string;
  pinOwnReplyEnabled?: boolean;
  commentBrief?: string | null;
  status: YoutubeTopicStatus;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface YoutubeTopicUpsertRequest {
  name: string;
  keyword: string;
  pinOwnReplyEnabled?: boolean;
  commentBrief?: string;
}

export interface YoutubeTopicAssignment {
  youtubeTopicId: number;
  threadAccountIds: number[];
}

export interface YoutubeVideoHit {
  videoId: string;
  title?: string | null;
  channelTitle?: string | null;
  thumbnailUrl?: string | null;
  publishedAt?: string | null;
  watchUrl?: string | null;
}

export function previewYoutubeVideos(keyword: string) {
  const q = encodeURIComponent(keyword);
  return request<YoutubeVideoHit[]>(
    `/api/youtube-topics/preview?keyword=${q}`,
    { method: 'GET' }
  );
}

export function listYoutubeTopicVideos(id: number) {
  return request<YoutubeVideoHit[]>(`/api/youtube-topics/${id}/videos`, {
    method: 'GET',
  });
}

export function listYoutubeTopics() {
  return request<YoutubeTopic[]>('/api/youtube-topics', { method: 'GET' });
}

export function createYoutubeTopic(payload: YoutubeTopicUpsertRequest) {
  return request<YoutubeTopic>('/api/youtube-topics', {
    method: 'POST',
    body: payload,
  });
}

export function updateYoutubeTopic(
  id: number,
  payload: YoutubeTopicUpsertRequest
) {
  return request<YoutubeTopic>(`/api/youtube-topics/${id}`, {
    method: 'PUT',
    body: payload,
  });
}

export function deleteYoutubeTopic(id: number) {
  return request<string>(`/api/youtube-topics/${id}`, { method: 'DELETE' });
}

export function listYoutubeTopicAssignments(id: number) {
  return request<YoutubeTopicAssignment>(
    `/api/youtube-topics/${id}/assignments`,
    { method: 'GET' }
  );
}

export function assignYoutubeTopicAccount(
  topicId: number,
  threadAccountId: number
) {
  return request<YoutubeTopicAssignment>(
    `/api/youtube-topics/${topicId}/assignments/${threadAccountId}`,
    { method: 'POST' }
  );
}

export function unassignYoutubeTopicAccount(
  topicId: number,
  threadAccountId: number
) {
  return request<YoutubeTopicAssignment>(
    `/api/youtube-topics/${topicId}/assignments/${threadAccountId}`,
    { method: 'DELETE' }
  );
}
